import { useState, useEffect } from 'react'
import { NavLink } from 'react-router-dom'
import { motion, AnimatePresence } from 'framer-motion'
import { Menu, X } from 'lucide-react'
import { Button } from '../ui/Button'

const navLinks = [
  { to: '/services', label: 'Services' },
  { to: '/services/ai-automation', label: 'AI Automation' },
  { to: '/security', label: 'Security' },
  { to: '/about', label: 'About' },
  { to: '/blog', label: 'Blog' },
]

export function Nav() {
  const [scrolled, setScrolled] = useState(false)
  const [mobileOpen, setMobileOpen] = useState(false)

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 80)
    window.addEventListener('scroll', onScroll)
    return () => window.removeEventListener('scroll', onScroll)
  }, [])

  return (
    <>
    <nav
      className={`fixed top-0 left-0 right-0 z-50 h-[72px] flex items-center justify-between px-6 transition-all duration-300 ${
        scrolled ? 'bg-bg-2/95 backdrop-blur-md border-b' : 'bg-transparent'
      }`}
      style={scrolled ? { borderColor: 'var(--accent-line)' } : {}}
    >
      <NavLink to="/" className="flex items-center shrink-0" aria-label="NextTech Consultants home">
        <img src="/NTC-LOGO-WHITE.svg" alt="NextTech Consultants" width={180} height={32} className="h-8 w-auto" />
      </NavLink>

      {/* Desktop links */}
      <div className="hidden md:flex items-center gap-8">
        {navLinks.map((link) => (
          <NavLink
            key={link.to}
            to={link.to}
            className={({ isActive }) =>
              `font-body font-medium transition-colors ${isActive ? 'text-accent' : 'text-cream-dim hover:text-white'}`
            }
          >
            {link.label}
          </NavLink>
        ))}
        <Button to="/contact" variant="primary" className="!py-2 !px-4 text-sm">
          Book a Call →
        </Button>
      </div>

      {/* Mobile menu button */}
      <button
        className="md:hidden p-2 text-white"
        onClick={() => setMobileOpen(!mobileOpen)}
        aria-label="Toggle menu"
      >
        {mobileOpen ? <X size={24} /> : <Menu size={24} />}
      </button>
    </nav>

    {/* Mobile menu */}
    <AnimatePresence>
      {mobileOpen && (
        <motion.div
          initial={{ opacity: 0, height: 0 }}
          animate={{ opacity: 1, height: 'auto' }}
          exit={{ opacity: 0, height: 0 }}
          className="fixed top-[72px] left-0 right-0 z-40 md:hidden overflow-hidden"
          style={{ backgroundColor: 'var(--bg-2)' }}
        >
          <div className="flex flex-col p-6 gap-4">
            {navLinks.map((link) => (
              <NavLink
                key={link.to}
                to={link.to}
                onClick={() => setMobileOpen(false)}
                className={({ isActive }) =>
                  `py-2 font-body font-medium ${isActive ? 'text-accent' : 'text-cream-dim'}`
                }
              >
                {link.label}
              </NavLink>
            ))}
            <Button to="/contact" variant="primary" fullWidth onClick={() => setMobileOpen(false)}>
              Book a Call →
            </Button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
    </>
  )
}
